import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/styles/myicon.css'
Vue.config.productionTip = false
import VueAMap from "vue-amap"; // 引入插件
Vue.use(VueAMap); // 使用插件
VueAMap.initAMapApiLoader({ // 初始化插件
    key: "e77d85204b9aacd472457ca317b98897", // 高德key，自己官网申请即可，这里是我申请的
    plugin: ["AMap.Geocoder"],  // 插件集合，这里只有一个定位功能，所以就只放一个AMap.Geocoder
    uiVersion: "1.0.11", // 不加会报错，加上吧
    v: "1.4.15", // 不加也不会影响，顺手加上吧
});
Vue.use(ElementUI);
new Vue({
  router,
  store,

  render: h => h(App)
}).$mount('#app')
